module.exports = __webpack_public_path__ + "img/mood-soso.9e522cf7.svg";